import { render, staticRenderFns } from "./SupplierEditorInfo.vue?vue&type=template&id=3ba9b827&"
import script from "./SupplierEditorInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierEditorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports